import { type ComponentProps } from 'react'
import { cn } from 'investments/common/utils'

import styles from './styles.module.css'

/**
 * Alternative to the deprecated Jade Box component
 */
export function Box({ className, hasPadding = false, ...rest }: ComponentProps<'div'> & { hasPadding?: boolean }) {
  return <div className={cn(styles.boxContainer, hasPadding ? styles.p5 : '', className)} {...rest} />
}
